module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "login"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('menu.login'),
      "level": 2,
      "font": "oswald",
      "color": "red",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pseudo),
      expression: "pseudo"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "txt",
    attrs: {
      "type": "text",
      "id": "pseudo",
      "name": "pseudo",
      "placeholder": _vm.$t('menu.username')
    },
    domProps: {
      "value": (_vm.pseudo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pseudo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formErrors.has('pseudo')),
      expression: "formErrors.has('pseudo')"
    }],
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.formErrors.first('pseudo')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "txt",
    attrs: {
      "type": "password",
      "id": "login-password",
      "name": "login-password",
      "placeholder": _vm.$t('menu.password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formErrors.has('login-password')),
      expression: "formErrors.has('login-password')"
    }],
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.formErrors.first('login-password')))]), _vm._v(" "), _c('input', {
    staticClass: "custom-btn",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.$t('menu.ok')
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eaff49e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = 254
// module chunks = 0